/**
 * Get the vehicle types from the current location.
 */

import type { RootState } from '/business/shared/state/store';
import type { VehicleType } from '/index';

export default (state: RootState): VehicleType | undefined => {
  const current = state.location?.current;
  return current && 'vehicleTypes' in current ? current.vehicleTypes : undefined;
};
